(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gun-ana-skin-needs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', (event) => {
    const details = event.target.closest('.ga-skin-needs__need');
    if (details) details.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  function updateGunAnaWelcomeCurrency(scope = document) {
    scope.querySelectorAll('[data-ga-gift-offer]').forEach((offer) => {
      const currency = offer.dataset.currency;
      const fixedThresholds = {"SEK":500,"EUR":50,"GBP":50,"USD":55,"CAD":75,"CHF":45,"CZK":1200,"DKK":350,"NOK":500,"HUF":17000,"ISK":6500,"MDL":1000,"PLN":210,"RON":250,"RSD":5500,"UAH":2400};
      const threshold = fixedThresholds[currency];
      if (!Number.isFinite(threshold)) return;
      const language = offer.dataset.language || 'en';
      const locale = language.includes('-') ? language : language + '-' + offer.dataset.country;
      try {
        offer.querySelector('[data-ga-gift-amount]').textContent = new Intl.NumberFormat(locale, {
          style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0
        }).format(threshold);
        offer.querySelector('[data-ga-gift-body]').hidden = false;
        offer.querySelector('[data-ga-gift-fallback]').hidden = true;
      } catch (_) {}
    });
  }

  updateGunAnaWelcomeCurrency();
  document.addEventListener('DOMContentLoaded', () => updateGunAnaWelcomeCurrency());
  document.addEventListener('shopify:section:load', (event) => updateGunAnaWelcomeCurrency(event.target));

  if (new URLSearchParams(window.location.search).get('preview_popup') === '1') {
    customElements.whenDefined('newsletter-popup').then(() => {
      updateGunAnaWelcomeCurrency();
      document.querySelector('.modal.ga-newsletter')?.show();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
